import React, { useState } from "react";
import "./eleve.scss";
import { Box, Divider, Skeleton, Tooltip } from "@mui/material";
import {
  AccountCircleRounded,
  ArrowBackRounded,
  CheckCircle,
  PeopleOutline,
  PictureAsPdfRounded,
  Print,
  Visibility,
} from "@mui/icons-material";
import _ from "lodash";

import { Link, useNavigate } from "react-router-dom";
import SearchBar from "../../component/searchBar/Search.tsx";
import SingleEleve from "../configuration/eleve/singleEleve.tsx";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import { accountService } from "../../_services/accountServices.js";
import { API_ELEVE } from "../../apiCaller/eleve.Caller.js";
import {
  EleveType,
  ParentType,
  PromotionType,
  requestType,
  schooYearType,
} from "../../types/GlobalType.ts";
import toast from "react-hot-toast";
import { API_CONFIG } from "../../apiCaller/configuration.Caller.js";
import { ANNEE_SCOLAIRE } from "../../App.constants.js";
import { API_PARENT } from "../../apiCaller/perent.Callerl.js";
import { eleveContext } from "../../context/AppContext.js";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";

const EleveList = () => {
  const [dataEleve, setDataEleve] = useState<EleveType[]>([]);
  const [singleDataEleve, setsingleDataEleve] = useState<EleveType>();

  const [dataSY, setDataSY] = useState<schooYearType[]>([]);
  const [openSingle, setOpenSingle] = useState<Boolean>(false);
  const [dataParent, setDataParent] = useState<ParentType[]>([]);
  const [reloadStateTwo, setreloadStateTwo] = useState(0);

  const [selectedAnneeValue, setselectedAnneeValue] = useState<string>(
    ANNEE_SCOLAIRE[ANNEE_SCOLAIRE.length - 1]
  );
  const [searchValue, setSearchValue] = useState<string>("");

  const navigate = useNavigate();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateEleve, setStateEleve] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateParent, setStateParent] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllParent = async () => {
    setStateParent({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_PARENT.PARENT.getAll(token);
      setDataParent(response.data.data);

      setStateParent({ ...state, isLoading: false });
    } catch (error: any) {
      setStateParent({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const fetchAllSY = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    API_CONFIG.ANNEE_SCOLAIRE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        setDataSY(response.data.data);
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };

  const fetchAllEleve = async () => {
    setStateEleve({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_ELEVE.PROMOTION.getAll(token);
      setDataEleve(response.data.data);

      setStateEleve({ ...state, isLoading: false });
    } catch (error: any) {
      setStateEleve({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK")
        return setStateEleve({
          ...state,
          isLoading: false,
          errorMessage: "ERR_NETWORK",
        });

      catchErrorApiCall(error);
    }
  };

  let sortedData: EleveType[] = [];
  if (dataEleve.length > 0) {
    sortedData = _.orderBy(dataEleve, ["nom"], ["asc"]);
  }
  // let sortedData: EleveType[] = [];
  // if (dataEleve.length > 0) {
  //   // Sort by "nom" ascending (same as _.orderBy([...], ["nom"], ["asc"]))
  //   sortedData = [...dataEleve].sort((a, b) => {
  //     if (a.nom < b.nom) return -1;
  //     if (a.nom > b.nom) return 1;
  //     return 0;
  //   });
  // }

  let filteredData: EleveType[] = [];
  filteredData = _.filter(
    sortedData,
    (item: PromotionType) =>
      item.annee_scolaire_designation === selectedAnneeValue
  );

  // let filteredData: EleveType[] = [];
  // // Same as _.filter(...)
  // filteredData = sortedData.filter(
  //   (item: PromotionType) =>
  //     item.annee_scolaire_designation === selectedAnneeValue
  // );

  const skeletonHeader = (
    <div className="configuration_">
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={150}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonSearchSection = (
    <div className="input-container">
      <Skeleton
        variant="rounded"
        height={30}
        width={250}
        sx={{ marginTop: "5px" }}
      />

      <div className="right_list_part">
        <Skeleton
          variant="rounded"
          height={30}
          width={"90%"}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="circular"
          height={30}
          width={30}
          sx={{ marginTop: "5px" }}
        />
      </div>
    </div>
  );
  const skeletonTable = (
    <Skeleton
      sx={{ marginTop: "10px" }}
      variant="rounded"
      height={500}
      width={"100%"}
    />
  );

  React.useEffect(() => {
    fetchAllSY();
    fetchAllEleve();
    fetchAllParent();
  }, [reloadStateTwo]);
  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "66px" }}
        >
          {state.isLoading ? (
            skeletonHeader
          ) : (
            <div className="configuration_">
              <div className="homeMenuCong">
                <Link to="/">
                  <ArrowBackRounded
                    sx={{
                      color: "#0091EA",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      mt: "5px",
                      cursor: "pointer",
                    }}
                  />
                </Link>
                <div className="homeTitleItem">
                  <Link to="/">
                    <span className="homeTitle"> Accueil </span>
                  </Link>
                </div>
                <div className="homeTitleItem">
                  <PeopleOutline sx={{ color: "#1565C0", mr: "10px" }} />
                  <span className="homeTitleSmall">Elèves </span>
                </div>
              </div>
              <div className="right__">
                <button className="add_button_pers">
                  <Tooltip title="Exporter PDF">
                    <PictureAsPdfRounded className="ico" />
                  </Tooltip>
                  exporter
                </button>
              </div>
            </div>
          )}

          <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

          <div className="card_Classe">
            {stateEleve.isLoading || stateParent.isLoading ? (
              skeletonSearchSection
            ) : (
              <div className="input-container">
                <div className="leftTitle">
                  <h2 className="card-title">Liste</h2>
                  <select
                    value={selectedAnneeValue}
                    onChange={(e) => setselectedAnneeValue(e.target.value)}
                    className="selectClasse"
                  >
                    {/* <option value="">-- Selectionner année --</option> */}
                    {dataSY.map((value, index) => {
                      return (
                        <option
                          key={index}
                          value={value.annee_scolaire_designation}
                        >
                          {value.annee_scolaire_designation.toUpperCase()}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="right_list_part">
                  <SearchBar
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    label="Rechercher..."
                  />
                  <button className="add_button_pers">
                    <Tooltip title="Imprimer">
                      <Print className="ico" />
                    </Tooltip>
                  </button>
                </div>
              </div>
            )}

            {stateEleve.isLoading || stateParent.isLoading ? (
              skeletonTable
            ) : (
              <div className="table_component" role="region">
                <table>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Noms</th>
                      <th>Genre</th>
                      <th>Classe</th>
                      <th>Année</th>
                      <th className="headerSection">Inscrits/Status</th>
                      <th className="actionHeader"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData
                      .filter(
                        (value) =>
                          value.nom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.postnom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.prenom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.classe_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase())
                      )
                      .filter((value) => value.eleve_status == "1")
                      .map((item, index) => {
                        let ownerParent: ParentType;
                        for (const element of dataParent) {
                          if (element.parent_id === item.parent_id) {
                            ownerParent = element;
                          }
                        }
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="userName">
                              <div className="userName">
                                <AccountCircleRounded />
                                {`${item.nom?.toUpperCase()} ${item.postnom?.toUpperCase()} ${item.prenom?.toUpperCase()}`}
                              </div>
                            </td>
                            <td>{item.sexe?.toLocaleUpperCase()}</td>
                            <td>
                              {item.classe_designation?.toLocaleUpperCase()}
                            </td>
                            <td>
                              {selectedAnneeValue
                                ? selectedAnneeValue
                                : "--------"}
                            </td>
                            <td className="statusSection">
                              <span>
                                <Tooltip title="Activé" placement="left">
                                  <CheckCircle
                                    style={{
                                      color: "#28a745",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Tooltip>
                              </span>
                            </td>
                            <td>
                              <div className="actionSection">
                                <span className="more">
                                  <Visibility
                                    className="ico"
                                    onClick={() => {
                                      setsingleDataEleve({
                                        ...item,
                                        parentNom: ownerParent.nom,
                                        parentPrenom: ownerParent.postnom,
                                        parentPostNom: ownerParent.prenom,
                                        parentSexe: ownerParent.sexe,
                                        parentPhone: ownerParent.telephone,
                                        parentVille: ownerParent.ville,
                                        parentCommune: ownerParent.commune,
                                        parentQuartier: ownerParent.quartier,
                                        parentAvenue: ownerParent.avenue,
                                      });
                                      setOpenSingle(true);
                                    }}
                                  />
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Box>
      )}

      {openSingle && (
        <eleveContext.Provider value={singleDataEleve}>
          <SingleEleve setOpen={setOpenSingle} setReload={setreloadStateTwo} />
        </eleveContext.Provider>
      )}

      {/* {openSingle && <SingleEleve setOpen={setOpenSingle} />} */}
    </>
  );
};

export default EleveList;
